import Firebase from 'firebase'
const firebaseApp = Firebase.initializeApp({
  apiKey: 'AIzaSyAE2VOfl1LCg-1Kwx-8ZSzaXHVLQZK4n_g',
  authDomain: 'honornine-d7c0e.firebaseapp.com',
  databaseURL: 'https://honornine-d7c0e.firebaseio.com',
  projectId: 'honornine-d7c0e',
  storageBucket: '',
  messagingSenderId: '1048507046921'
})

export default firebaseApp



// WEBPACK FOOTER //
// ./src/classes/Db.js